import { Download, Trash2 } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface FileActionBarProps {
  onDownload: () => void;
  onDelete: (() => void) | null;
}

export function FileActionBar({ onDownload, onDelete }: FileActionBarProps): React.ReactElement {
  return (
    <div className="flex items-center gap-1 px-2 py-1.5 bg-muted/40 shrink-0">
      <div className="flex-1" />
      <Button onClick={onDownload} size="icon" variant="ghost" className="h-7 w-7">
        <Download size={16} />
      </Button>
      {onDelete != null && (
        <Button
          onClick={onDelete}
          size="icon"
          variant="ghost"
          className="h-7 w-7 text-destructive hover:text-destructive"
        >
          <Trash2 size={16} />
        </Button>
      )}
    </div>
  );
}

export function downloadFile(url: string, fileName: string): void {
  fetch(url, { credentials: 'include' })
    .then((res) => res.blob())
    .then((blob) => {
      const blobUrl = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(blobUrl);
    });
}
